import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AuraAccordion = ({
  title,
  isExpanded,
  onChange,
  children,
  styles = {},
  dataTestId,
}) => {
  return (
    <Accordion
      expanded={isExpanded}
      onChange={onChange}
      data-testid={dataTestId}
       sx={{
          ...(styles.root || {}),
          ...(isExpanded && styles.rootExpanded), 
        }}
      >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title}-content`}
        id={`${title}-header`}
        data-testid={dataTestId ? `${dataTestId}-summary` : undefined}
         sx={{
          ...(styles.summary || {}),
          ...(isExpanded && styles.summaryExpanded),
          '& .MuiAccordionSummary-content.Mui-expanded': {
            ...(styles.summaryContentExpanded || {}),
          },
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold" sx={styles.title}>
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={styles.details}>{children}</AccordionDetails>
    </Accordion>
  );
};

export default AuraAccordion;
